import { userActions } from '@/core/state/user'

/**
 * Tier detection from the URL and localStorage — main.js's cascade, now over the
 * Zustand session directly. Runs once in main.tsx before the router reads the
 * URL, exactly where main.js ran it (before vue-router's first guard).
 *
 *   ?demo=true | ?tier=demo      → the demo experience, explicitly
 *   a saved session              → its tier and workspace
 *   a token, ?tier=enterprise|pro, ?demo=false → the full app
 *   nothing                      → demo
 *
 * The user store's own actions persist and clean the URL. The old
 * "?demo=true after the forced-demo check" branch was unreachable and is not
 * carried over.
 */
export function bootstrapSession() {
  const authToken = localStorage.getItem('auth_token')
  const savedWorkspaceId = localStorage.getItem('workspace_id')
  const savedUserTier = localStorage.getItem('user_tier')
  const params = new URLSearchParams(window.location.search)
  const tierParam = params.get('tier')
  const demoParam = params.get('demo')

  if (demoParam === 'true' || tierParam === 'demo') {
    userActions.setDemoMode(true)
    return
  }
  if (authToken && savedUserTier) {
    userActions.setTier(savedUserTier)
    if (savedWorkspaceId) userActions.setWorkspaceId(parseInt(savedWorkspaceId, 10))
    if (savedUserTier !== 'demo') userActions.clearDemoParams()
    return
  }
  if (authToken || tierParam === 'enterprise' || tierParam === 'pro' || demoParam === 'false') {
    userActions.setDemoMode(false)
    userActions.clearDemoParams()
    return
  }
  userActions.setDemoMode(true)
}
